import React, { useState, useEffect } from "react";
import Dropzone from "react-dropzone";
import { useParams } from "react-router-dom";
import Axios from "axios";
import { useRecoilValue } from "recoil";
import { tokenAtom } from "../../global/globalState";
import Aws from "aws-sdk";

const Assignment = ({ route }) => {
    const [files, setFiles] = useState(null);
    const token = useRecoilValue(tokenAtom);
    const { id } = useParams();
    const [assignment, setAssignment] = useState(null);
    const [progress, setProgress] = useState("");

    useEffect(() => {
        Axios.post(
            `${process.env.REACT_APP_API_URL}/student/getassignmentbyid`,
            {
                assignmentId: id,
            },
            {
                headers: {
                    Authorization: "Bearer " + token,
                },
            }
        )
            .then((res) => {
                setAssignment(res.data.response.assignmentDetails);
                console.log(res.data.response.assignmentDetails);
                console.log(assignment, "asst");
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    useEffect(() => {
        console.log(progress, "progress");

        if (progress === 100) {
            Axios.post(
                "http://localhost:5000/student/upload",
                {
                    assignmentUploaded:
                        "https://aqua-assignment.s3-ap-southeast-1.amazonaws.com/assignments/" +
                        files[0].name,
                    assignmentId: id,
                },
                {
                    headers: {
                        Authorization: "Bearer " + token,
                    },
                }
            )
                .then((res) => {
                    console.log(res.data, "saving ass to db");
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }, [progress]);

    Aws.config.update({
        accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
        secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
    });

    const bucket = new Aws.S3({
        params: {
            Bucket: "aqua-assignment",
        },
        region: "ap-southeast-1",
    });

    const uploadFile = () => {
        const params = {
            ACL: "public-read",
            Key: "assignments/" + files[0].name,
            ContentType: files[0].type,
            Body: files[0],
        };

        bucket
            .putObject(params)
            .on("httpUploadProgress", () => {
                setProgress(100);
            })
            .send((err) => {
                if (err) {
                    console.log(err);
                }
            });
    };

    return (
        <div className="Assignment">
            <div className="container assignment">
                <h1>Assignment </h1>
                <div className="assignment-id">
                    <strong>ID</strong> : {id}
                </div>
                <div className="assignment-description">
                    <strong>DESCRIPTION </strong>:{" "}
                    {assignment && assignment.description}
                </div>
                <div className="box">
                    <div className="box1"></div>
                    <div className="box2"></div>
                    <div className="box3"></div>
                </div>

                <div className="assignment-work">
                    <div className="assignment-work-title">FILES ATTACHED</div>
                    <div className="assignment-work-attached">
                        <div className="assignment-work-attached-file">
                            <img
                                src="https://via.placeholder.com/150"
                                alt="Placeholder"
                            />
                            <div className="assignment-work-attached-file-title">
                                {assignment &&
                                    assignment.assignmentGiven.substring(68)}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="box">
                    <div className="box1"></div>
                    <div className="box2"></div>
                    <div className="box3"></div>
                </div>

                <div className="assignment-files">
                    <div className="assignment-files-title">
                        SUBMIT YOUR WORK
                    </div>
                    <div className="dropzone-container">
                        <Dropzone
                            onDrop={(files) => {
                                setFiles(files);
                                console.log(files);
                            }}
                            accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        >
                            {({
                                getRootProps,
                                getInputProps,
                                isDragActive,
                                isDragAccept,
                                isDragReject,
                            }) => {
                                const additionalClass = isDragAccept
                                    ? "accept"
                                    : isDragReject
                                    ? "reject"
                                    : "";

                                return (
                                    <div
                                        {...getRootProps({
                                            className: `dropzone ${additionalClass}`,
                                        })}
                                    >
                                        <input {...getInputProps()} />
                                        <span>
                                            {isDragActive ? "📂" : "📁"}
                                        </span>
                                        <p>
                                            Drag'n'drop images, or click to
                                            select files
                                        </p>
                                    </div>
                                );
                            }}
                        </Dropzone>
                        {files && (
                            <div className="selected-file">
                                Selected File : {files[files.length - 1].name}
                            </div>
                        )}
                    </div>
                    <button
                        className="primary submit"
                        onClick={() => uploadFile()}
                    >
                        SUBMIT
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Assignment;
